import { useMemo, useState } from "react";
import { MoreHorizontal, UserCog, Handshake, Upload, FolderOpen, Trash2 } from "lucide-react";
import { toast } from "sonner";

// Menù «⋯» dell'intestazione della scheda cliente.
export default function AzioniCliente({ cliente, nPratiche, onAnagrafica, onSegnalatore, onCarica, onElimina, puoEliminare }) {
  const [open, setOpen] = useState(false);
  const voci = useMemo(() => [
    { k: "anagrafica", l: "Modifica anagrafica", i: UserCog, f: onAnagrafica },
    { k: "segnalatore", l: cliente.referente_id ? "Cambia segnalatore" : "Aggiungi segnalatore", i: Handshake, f: onSegnalatore },
    { k: "carica", l: "Carica documenti", i: Upload, f: onCarica },
    ...(cliente.drive_folder
      ? [{ k: "drive", l: "Apri la cartella Drive", i: FolderOpen, f: () => window.open(cliente.drive_folder, "_blank") }] : []),
    ...(puoEliminare
      ? [{ k: "elimina", l: "Elimina cliente", i: Trash2, rosso: true,
         f: nPratiche > 0
           ? () => toast.error("Ha pratiche collegate: si può eliminare solo un cliente senza pratiche.")
           : onElimina }] : []),
  ], [cliente, nPratiche, onAnagrafica, onSegnalatore, onCarica, onElimina, puoEliminare]);

  return (
    <div className="relative">
      <button data-testid="azioni-cliente" onClick={() => setOpen(!open)} aria-label="Altre azioni sul cliente"
        className="w-10 h-10 grid place-items-center rounded-full border border-[#B9B5A9] bg-white text-[#1B2A4B]
                   hover:border-[#A8863F] hover:text-[#A8863F] transition-colors">
        <MoreHorizontal className="w-5 h-5" />
      </button>
      {open && (
        <>
          <button aria-hidden className="fixed inset-0 z-[55] cursor-default" onClick={() => setOpen(false)} />
          <div data-testid="azioni-cliente-menu"
            className="absolute right-0 mt-2 z-[56] w-64 rounded-[6px] border border-[#E2E0D9] bg-white shadow-[0_18px_38px_-18px_rgba(27,42,75,0.45)] overflow-hidden">
            {voci.map((v) => (
              <button key={v.k} data-testid={`azione-cliente-${v.k}`} onClick={() => { setOpen(false); v.f?.(); }}
                className={`w-full flex items-center gap-2.5 px-3.5 py-2.5 text-[13px] text-left transition-colors
                  ${v.rosso ? "text-[#8A2E2E] hover:bg-[#FDF6F6]" : "text-[#1B2A4B] hover:bg-[#F7F6F2]"}`}>
                <v.i className={`w-4 h-4 ${v.rosso ? "" : "text-[#A8863F]"}`} /> {v.l}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
